// src/register.ts
async function registerSW(scriptUrl, config = {}) {
  if (!("serviceWorker" in navigator)) {
    throw new Error("Service workers not supported in this browser");
  }
  const registration = await navigator.serviceWorker.register(scriptUrl, {
    scope: config.scope
  });
  let updateTimer = null;
  function onStateChange(sw) {
    sw.addEventListener("statechange", () => {
      if (sw.state === "activated") {
        config.onReady?.(registration);
      }
    });
  }
  if (registration.active) {
    config.onReady?.(registration);
  }
  if (registration.installing) {
    onStateChange(registration.installing);
  }
  if (registration.waiting) {
    config.onUpdate?.(registration);
  }
  registration.addEventListener("updatefound", () => {
    const newWorker = registration.installing;
    if (!newWorker) return;
    newWorker.addEventListener("statechange", () => {
      if (newWorker.state === "installed" && navigator.serviceWorker.controller) {
        config.onUpdate?.(registration);
      }
    });
  });
  function onMessage(event) {
    if (event.data?.type) {
      config.onMessage?.(event.data);
    }
  }
  navigator.serviceWorker.addEventListener("message", onMessage);
  function onOnline() {
    config.onOnline?.();
  }
  function onOffline() {
    config.onOffline?.();
  }
  if (config.onOnline) window.addEventListener("online", onOnline);
  if (config.onOffline) window.addEventListener("offline", onOffline);
  const interval = config.updateInterval ?? 36e5;
  if (interval > 0) {
    updateTimer = setInterval(() => {
      registration.update().catch(() => {
      });
    }, interval);
  }
  return {
    registration,
    async update() {
      await registration.update();
    },
    async unregister() {
      return registration.unregister();
    },
    skipWaiting() {
      registration.waiting?.postMessage({ type: "SKIP_WAITING" });
    },
    dispose() {
      if (updateTimer) {
        clearInterval(updateTimer);
        updateTimer = null;
      }
      navigator.serviceWorker.removeEventListener("message", onMessage);
      if (config.onOnline) window.removeEventListener("online", onOnline);
      if (config.onOffline) window.removeEventListener("offline", onOffline);
    }
  };
}

export { registerSW };
//# sourceMappingURL=register.mjs.map
//# sourceMappingURL=register.mjs.map